import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
//import { Subscription } from 'rxjs/Subscription';
//import { NgbProgressbarConfig } from '@ng-bootstrap/ng-bootstrap';
import {GridOptions} from "ag-grid/main";
import {Subject} from 'rxjs';
//import { debounceTime } from 'rxjs/operators';
import {
  AgGridUtility,
  AUDIT_BTN,
  AUDIT_ENTITY_COLUMN_DEFS,
  AUDIT_ENTITY_ID,
  AUDIT_ENTITY_TYPE,
  AUDIT_PAGE_TITLE,
  CommonUtility,
  DataService,
  DateUtility,
  DOUBLE_ROW_HEADER,
  EDIT_BTN,
  PAGE_ID,
  Reimbursements,
  ReimbursementsSummary,
  ServerConstantsService,
  VIEW_BTN,
  WpEtEnrollment,
  WpPerson
} from '../shared';
import {ReferenceTableService} from '../reference-table.service';
import {NotificationsService} from 'angular2-notifications';
import {Role} from "../shared/model/role.model";

@Component({
  selector: 'app-reimbursements-summary',
  templateUrl: './reimbursements-summary.component.html',
  styleUrls: ['./reimbursements-summary.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class ReimbursementsSummaryComponent implements OnInit {
  AUDIT_ENTITY_ID: string = AUDIT_ENTITY_ID;
  AUDIT_ENTITY_COLUMN_DEFS: string = AUDIT_ENTITY_COLUMN_DEFS;
  AUDIT_ENTITY_TYPE: string = AUDIT_ENTITY_TYPE;
  AUDIT_PAGE_TITLE: string = AUDIT_PAGE_TITLE;
  PAGE_ID: string = PAGE_ID;

  DOUBLE_ROW_HEADER = DOUBLE_ROW_HEADER;
  reimbursement: Reimbursements;
  sortedReimbursement: Reimbursements;
 // enrollmentId: Number;
  reimbursements: Reimbursements[] = [];
  reimbursementsSummary: ReimbursementsSummary;
  //programMap: any;
  //relationshipArray: any[];
  isSystemCoordinator: Boolean = false;
  //relationshipMap: any;
  //elasticSuggestions = new BehaviorSubject<any>(null);
 // elasticSuggestionsUser = new BehaviorSubject<any>(null);
  //suggestions: any = [];
 // suggestionsUser: any = [];
  ServerConstants: any;
  userActionNotificationsMap: any;
  refData: any;
  sharedData: any;
  //currentSearch: String;
  //wpenrollmentId: string = '';
  wpPersonId: string = '';
  referralId: string = '';
  noData: Boolean = false;
 // error: Boolean = false;
  isAvailableBalance: boolean = true;
  //caseNoteMap: any;
  roles: Role[];
  availableBalance: number;

  availableBalanceStr: String = '';
  private gridOptions: GridOptions;
  columnDefs: any;
  context: any;

  //taskStatusJson: any;
  //countiesJson: any;
  //countiesMap: any;
  //counties: any;
  // assignedToJson: any;
  // assignedToMap: any;
  // assignedToDD: any;
  reimbReasonMap: any;
  reimbDecisionArray: any[];
  reimbDecisionMap: any;
  // shortTermGoalMap: any;
  // longTermGoalMap: any;
  // shortTermGoalArray: any[];
  // longTermGoalArray: any[];
  reimbReasonArray: any[];
  reimbBalanceArray: any[];
  wpPerson: WpPerson;
  private _success = new Subject<string>();
  successMessage: string;
  private _danger = new Subject<string>();
  errorMessage: string;
  firstName: string;
  auditColumnDefs: any; //audit
  index:any;
  gridApi: any;
  tabToNextCell: any;
  firstTime: Boolean = true;
  tabIndex:any = "-1";
  selectedfiscalYear:any;
  latestEnrollment: WpEtEnrollment;
  enrollmentEndDt: any = null;
  disableAddNew: Boolean = false;
  fiscalyearArray:any=[];

  @ViewChild('header') header: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    public dataService: DataService,
    private dateUtility: DateUtility,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private agGridUtility: AgGridUtility,
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
    this.gridOptions = <GridOptions>{};
    if(this.dataService.getSharedDataObject().get('RIMBS') == undefined){
      this.router.navigate(['/task']);
    }
  }


  ngOnInit() {
    /* Load Reference Tables*/
    this.dataService.globalAccess = true;
    this.index = this.dataService.getSharedDataObject().get("RIMBS").innerNavPages.find(x=> x.pageId === 'RIMSU');
    if(this.index.readOnly == true){
      this.tabIndex = "0";
    }
    this.parseRefTableData();

    this.data.currentFirstName.subscribe(
      (message) => {
        this.firstName = message;

      });
    this.reimbursementsSummary = new ReimbursementsSummary();
    this.sharedData = this.dataService.getSharedDataObject();
    this.roles = this.sharedData.get('roles');
    this.userAccess();
    if (this.sharedData.get('wpPersonId') !== null && this.sharedData.get('wpPersonId') !== undefined) {
      this.reimbursementsSummary.personId = Number(this.sharedData.get('wpPersonId'));
    }
    if(new Date().getMonth() >= 9){
      this.selectedfiscalYear = "Fiscal Year " + (new Date().getFullYear()+1);
      this.fiscalyearArray.push("Fiscal Year " + (new Date().getFullYear()+1));
      this.fiscalyearArray.push("Fiscal Year " + (new Date().getFullYear()));
      this.reimbursementsSummary.year = Number(new Date().getFullYear()+1);
    }
    else{
      this.selectedfiscalYear = "Fiscal Year " + (new Date().getFullYear());
      this.fiscalyearArray.push("Fiscal Year " + (new Date().getFullYear()));
      this.fiscalyearArray.push("Fiscal Year " + (new Date().getFullYear()-1));
      this.reimbursementsSummary.year = Number(new Date().getFullYear());
    }
    this.getColumnDefinitions();
    // Audit Method
    this.auditColumnDefinations();
    this.load();

    console.log('Selected Fiscal Year : ' + this.selectedfiscalYear);
    this.disableAddNewButton();

  }
  changefiscalyear(event){
    this.reimbBalanceArray = this.data.getValueFromSharedDataMap("REIMBURSEMENTAMOUNT");
    for (let balance of this.reimbBalanceArray) {
      if (balance.value === 'AB') {
        this.availableBalance = parseFloat(balance.name);
      }
    }
    this.reimbursementsSummary.year = parseInt(this.selectedfiscalYear.substring(12));
    this.load();
  }
  getColumnDefinitions() {
    this.columnDefs = [
      {
        headerName: 'Payee/Vendor Name',
        field: 'vendorName',
        width: 200,     
      },
      {
        headerName: 'Reason',
        field: 'reasonCd',
        refData: this.reimbReasonMap,
        width: 200,
      },
      {
        headerName: 'Requested Date',
        field: 'requestedDt',
        width: 200,
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.filterDates,
        },
      },
      {
        headerName: 'Requested Amount',
        field: 'requestedAmount',
        width: 200,
        filter: "agTextColumnFilter",
        valueFormatter: this.agGridUtility.formatAmount,
      },
      {
        headerName: 'Authorized Date',
        field: 'authorizedDt',
        filter: "agDateColumnFilter",
        width: 210,
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.filterDates,
        }
        ,
      },
      {
        headerName: 'Authorized Amount',
        field: 'authorizedAmount',
        filter: "agTextColumnFilter",
        width: 210,
        valueFormatter: this.agGridUtility.formatAmount,
      },
      {
        headerName: 'Action',
        field: '',
        cellRenderer: this.getEditButton,
        suppressFilter: true,
        suppressSorting: true,
        width: 130,

      },
    ];

    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellDef;
      if (nextCell == null || nextCell.column.colDef.headerName === 'Action') {
        return;
      } else {
        return nextCell;
      }
    };

    this.context = {
      component: this,
    };
  }

  auditColumnDefinations() {
    this.auditColumnDefs = [
      {
        headerName: 'Requested Date',
        field: 'requestedDt',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.filterDates,
        },
        tooltip: this.agGridUtility.formatTimeDateToDate
      },
      {
        headerName: 'Authorized Date',
        field: 'authorizedDt',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.filterDates,
        },
        tooltip: this.agGridUtility.formatTimeDateToDate
      },
      {
        headerName: 'Reason',
        field: 'reasonCd',
        refData: this.reimbReasonMap,
        tooltip: (params) => {
          const reimbReasonList = params.context.reimbReasonMap;
          const reimReasonCd = params.data.reasonCd;
          const reimReason = reimbReasonList[reimReasonCd];
          return reimReason;
        }
      },
      {
        headerName: 'Reimbursement Status',
        field: '',
        valueGetter: this.getReimbStatus,
        tooltip: this.getReimbStatus
      },
      {
        headerName: 'Modified By',
        field: 'createdBy',
        tooltipField: 'createdBy'
      },
      {
        headerName: 'Modified Date',
        field: 'createdDate',
        filter: "agDateColumnFilter",
        valueFormatter: this.agGridUtility.formatTimeDateToDateTime,
        filterParams: {
          comparator: this.filterDates,
        },
        tooltip: this.agGridUtility.formatTimeDateToDateTime,
      },
      {
        headerName: 'Requested Amount',
        field: 'requestedAmount',
        filter: "agTextColumnFilter",
        valueFormatter: this.agGridUtility.formatAmount,
        tooltip: this.agGridUtility.formatAmount
      },
      {
        headerName: 'Authorized Amount',
        field: 'authorizedAmount',
        filter: "agTextColumnFilter",
        valueFormatter: this.agGridUtility.formatAmount,
        tooltip: this.agGridUtility.formatAmount
      },
      {
        headerName: 'Reimbursement Decision',
        field: 'decisionCd',
        refData: this.reimbDecisionMap,
        tooltip: (params) => {
          const reimbDecisionMap = params.context.reimbDecisionMap;
          const reimbDecisionCode = params.data.decisionCd;
          const reimbDecision = reimbDecisionMap[reimbDecisionCode];
          return reimbDecision;
        }
      }
    ];
  }

  getReimbStatus(params) {
    let reimStatus;
    if (params.data.decisionCd === "BE" || params.data.decisionCd === "TE") {
      reimStatus = 'Complete';
    } else {
      reimStatus = 'In Progress';
    }
    return reimStatus;
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridOptions.api = params.api;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }

  onResize(event) {
    if(window.screen.width >= window.innerWidth){
      this.gridOptions.columnDefs = this.columnDefs;
    }
    else{
      this.gridOptions.api.sizeColumnsToFit();
    }
  }

  formatDates(params) {
    if (!params.value) {
      return null;
    }
    const dateParts = params.value;
    const day = dateParts[2];
    const month = dateParts[1];
    const year = dateParts[0];
    return month + '-' + day + '-' + year;
  }


  filterDates(filterLocalDateAtMidnight, cellValue) {
    if (!cellValue) {
      return;
    }
    const dateParts = cellValue.split("-");
    const day = Number(dateParts[2]);
    const month = Number(dateParts[1]) - 1;
    const year = Number(dateParts[0]);
    const cellDate = new Date(year, month, day);
    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    } else if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    } else {
      return 0;
    }
  }

  getEditButton(params) {
    const that = params.context.component;
    const page = that.dataService.sharedDataMap;
    const pageId = page.get("RIMBS").pageId;

    const divRow = document.createElement('div');
    divRow.setAttribute("class", "row");

    //Audit Button
    const auditElement = document.createElement('a');
    const auditImage = AUDIT_BTN;
    auditElement.innerHTML = auditImage;
    auditElement.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('component', params.context.component);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.Reimbursements');
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
      that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Reimbursement Audit');
      that.dataService.addValueToSharedDataMap(that.PAGE_ID, pageId);
      that.router.navigate(['/task/reimbursementsSummary/auditHistory']);
    });

    // START ADA
    auditElement.addEventListener('keydown', (event) => {
      if(event.keyCode === 13 || event.keyCode === 32){
        that.dataService.addValueToSharedDataMap('component', params.context.component);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.Reimbursements');
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
        that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Reimbursement Audit');
        that.dataService.addValueToSharedDataMap(that.PAGE_ID, pageId);
        that.router.navigate(['/task/reimbursementsSummary/auditHistory']);
      }
    });


    auditElement.setAttribute("tabindex", "0");
    // END ADA

    // Edit Button
    if (that.isSystemCoordinator) {
      const element = document.createElement('a');
      const image = EDIT_BTN;
      element.innerHTML = image;
      element.addEventListener('click', () => {
        that.dataService.addValueToSharedDataMap('reimbursement', params.data);
        that.router.navigate(['/task/reimbursementsSummary/reimbursements']);
      });
      // START ADA
      element.addEventListener('keydown', (event) => {
        if(event.keyCode === 13 || event.keyCode === 32){
          that.dataService.addValueToSharedDataMap('reimbursement', params.data);
          that.router.navigate(['/task/reimbursementsSummary/reimbursements']);
        }
        else if(event.keyCode == 9){
          event.preventDefault();
          setTimeout(() => auditElement.focus(), 0);
        }
      });

      element.setAttribute("tabindex", "0");

      // END ADA
      const divCol1 = document.createElement('div');
      divCol1.setAttribute("class", "col-2 right-margin-1");
      divCol1.appendChild(element);

      const divCol2 = document.createElement('div');
      divCol2.setAttribute("class", "col-1");
      divCol2.appendChild(auditElement);
      divRow.appendChild(divCol1);
      divRow.appendChild(divCol2);

      return divRow;
    } else {
      const that = params.context.component;
      const element = document.createElement('a');
      const image = VIEW_BTN;
      element.innerHTML = image;
      element.addEventListener('click', () => {
        that.dataService.addValueToSharedDataMap('reimbursement', params.data);
        that.router.navigate(['/task/reimbursementsSummary/reimbursements']);
      });
      // START ADA
      element.addEventListener('keydown', (event) => {
        if(event.keyCode === 13 || event.keyCode === 32){
          that.dataService.addValueToSharedDataMap('reimbursement', params.data);
          that.router.navigate(['/task/reimbursementsSummary/reimbursements']);
        }
        else if(event.keyCode == 9){
          event.preventDefault();
          setTimeout(() => auditElement.focus(), 0);
        }
      });
      element.setAttribute("tabindex","0");

      // END ADA
      const divCol1 = document.createElement('div');
      divCol1.setAttribute("class", "col-2 right-margin-1");
      divCol1.appendChild(element);

      // //Audit Button
      // const auditElement = document.createElement('a');
      // const auditImage = AUDIT_BTN;
      // auditElement.innerHTML = auditImage;
      // auditElement.addEventListener('click', () => {
      //   that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
      //   that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.Reimbursements');
      //   that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
      //   that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Reimbursement Audit');
      //   that.dataService.addValueToSharedDataMap(that.PAGE_ID, pageId);
      //   that.router.navigate(['/task/auditHistory'])
      // });

      const divCol2 = document.createElement('div');
      divCol2.setAttribute("class", "col-1");
      divCol2.appendChild(auditElement);
      divRow.appendChild(divCol1);
      divRow.appendChild(divCol2);

      return divRow;
    }
  }
  load() {
    this.reimbBalanceArray = this.data.getValueFromSharedDataMap("REIMBURSEMENTAMOUNT");
    for (let balance of this.reimbBalanceArray) {
      if (balance.value === 'AB') {
        this.availableBalance = parseFloat(balance.name);
      }
    }
    this.http.post<ReimbursementsSummary>(this.ServerConstants.REIM_SERVER_API + '/reimbursements/load', this.reimbursementsSummary).subscribe(
      (data: ReimbursementsSummary) => {
        if (data.hasOwnProperty('errorCode')) {
          this.notificationService.error('Reimbursements Summary', this.userActionNotificationsMap.ERROR);
          this.availableBalanceStr = parseFloat((Math.round(this.availableBalance * 100) / 100)+'').toFixed(2);
        } else {          
          //if (data.reimbursements != null) {
            if (data.reimbursements != null && data.reimbursements.length > 0) {
              this.reimbursements = data.reimbursements;
              this.reimbursements.forEach(element => {
                // console.log(-((Number)(element.requestedAmount)-(Number)(element.authorizedAmount)));
                console.log("element.id==="+element.id);
                console.log("element.decisionCd==="+element.decisionCd);
                if (element.decisionCd !== undefined && element.decisionCd !== null) {
                  if (element.decisionCd === 'BE') {
                    let a = ((Number)(element.authorizedAmount));
                    this.availableBalance = this.availableBalance - a;
                
                  }
                  else if (element.decisionCd === 'RP') {
                    let a = ((Number)(element.requestedAmount));
                    this.availableBalance = this.availableBalance - a;
                
                  }
                  else if (element.decisionCd === 'RR') {
                    let a = ((Number)(element.requestedAmount));
                    this.availableBalance = this.availableBalance;
                    
                  }
                  else if (element.decisionCd === 'TE') {

                    let a = ((Number)(element.requestedAmount));
                    this.availableBalance = this.availableBalance;
                    //+(Number)(element.authorizedAmount))
                  } 
                } else {
                  let a = ((Number)(element.requestedAmount));
                  this.availableBalance = this.availableBalance - a;
                }

                if(element.vendorName == undefined || element.vendorName == null || element.vendorName=='') {
                  element.vendorName=element.payeeFirstName + " " + element.payeeLastName;
                }
                  
              });
              console.log("reimbursement availableBalance final==="+this.availableBalance);
                

              if (this.availableBalance > 0) {
                this.isAvailableBalance = true;
                this.availableBalance = (Number)(String(this.availableBalance));
                 this.dataService.addValueToSharedDataMap('isAvailableBalance', 'Y');
              }
              else if (this.availableBalance < 0) {
                this.isAvailableBalance = false;
                this.availableBalance = (Number)((String(this.availableBalance)).split("-")[1]);
                this.dataService.addValueToSharedDataMap('isAvailableBalance', 'N');
              }
              
              this.availableBalanceStr = parseFloat((Math.round(this.availableBalance * 100) / 100)+'').toFixed(2);
              this.dataService.addValueToSharedDataMap('availableBalance', this.availableBalance);
            } else {
              this.reimbursements = [];
              this.noData = true;
              this.availableBalanceStr = parseFloat((Math.round(this.availableBalance * 100) / 100)+'').toFixed(2);
              this.dataService.removeValueFromSharedDataMap('availableBalance');
              this.dataService.removeValueFromSharedDataMap('isAvailableBalance');
              this.dataService.addValueToSharedDataMap('availableBalance', this.availableBalance);
            }
          //}
        }
      }, response => {
        //this.error = true;
        this.notificationService.error('Reimbursements Summary', this.userActionNotificationsMap.ERROR);
        this.availableBalanceStr = parseFloat((Math.round(this.availableBalance * 100) / 100)+'').toFixed(2);
      }, () => {
       // this.error = false;
      });
  }

  parseRefTableData() {
    this.reimbReasonArray = this.data.getValueFromSharedDataMap("ReimbReasonDesc");
      this.reimbReasonMap = this.commonUtil.createNativeMapFromList(this.reimbReasonArray);
    this.reimbDecisionArray = this.data.getValueFromSharedDataMap("ReimbDecisionDesc");
      this.reimbDecisionMap = this.commonUtil.createNativeMapFromList(this.reimbDecisionArray);
    this.reimbBalanceArray = this.data.getValueFromSharedDataMap("REIMBURSEMENTAMOUNT");
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(this.data.getValueFromSharedDataMap("USER-ACTION-NOTIFICATIONS"));

    for (let balance of this.reimbBalanceArray) {
      if (balance.value === 'AB') {
        this.availableBalance = parseFloat(balance.name);
      }
    }
  }

  userAccess() {
    for (const role of this.roles) {
      if (role.id === 4) {
        this.isSystemCoordinator = true;
      }
      else {
        this.isSystemCoordinator = false;
      }
    }
  }

  loadreimbursementsDetails() {

    const isNewRequest = true; 
    this.router.navigate(['/task/reimbursementsSummary/reimbursements'],{ queryParams: { isNewRequest: isNewRequest } });
    this.dataService.removeValueFromSharedDataMap('reimbursement');
  }

  focusSummary(e) {
    this.firstTime = false;
    this.addEventListenerToButton(e);
  }

  addEventListenerToButton(event){
    var tabKeyCode = 9;

    // ignore non tab key strokes
    if(event.keyCode !== tabKeyCode) {
      return;
    }

    if(this.reimbursements.length === 0){
      return;
    }

    if(event.shiftKey){
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }

  setDisplayedRowAtIndex() {
    // get the first row

    var index = this.gridApi.getFirstDisplayedRow();
    var rowNode =  this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell
    this.gridApi.setFocusedCell(index, firstCol);
  }

  focusing(event){
    if(!event.shiftKey && event.keyCode==9){
      event.preventDefault();
      setTimeout(() => this.header.nativeElement.focus(), 0);
      this.header.nativeElement.click();
    }
  }

  onPaginationChanged(event) {
    if (this.firstTime) {
      return;
    } else {
      if (this.gridApi) {
        this.setDisplayedRowAtIndex();
      }
    }
  }

  gridClick() {
    this.firstTime = false;
  }
  filter(event){
    this.firstTime = true;
  }

  
  disableAddNewButton() {
    this.http.post<WpEtEnrollment>(this.ServerConstants.COMMON_SERVER_API_URL +
      '/wp-et-enrollment/latest', {
        'personId': Number(this.reimbursementsSummary.personId),
        'referralId': Number(this.referralId)
      }).subscribe(
        (data: WpEtEnrollment) => {
          if (data != null && !data.hasOwnProperty('errorCode')) {
            this.latestEnrollment = data;
            console.log("ReimbursementPage- this.latestEnrollment.enrollmentEndDt: " + this.latestEnrollment.enrollmentEndDt );
            if (this.latestEnrollment.enrollmentEndDt != null
              && this.latestEnrollment.enrollmentEndDt !== undefined) {
              this.enrollmentEndDt = this.dateUtility.convertDateFromServer(this.latestEnrollment.enrollmentEndDt);
              console.log("ReimbursementPage- enrollmentEndDt: " + this.enrollmentEndDt );
  
              //Check fiscal year of enrollmentEndDt
              var etEndDt = new Date(this.latestEnrollment.enrollmentEndDt);
              const month = etEndDt.getMonth() + 1;
              var year = etEndDt.getFullYear();

              console.log("month: " + month );
              console.log("year: " + year );
              
              if(month < 10) {
                console.log('EnrollmentEndDate is in Fiscal year : ' + year);
                var reimbursementSubmissionCutoffDt = new Date(year, 10, 15);
              } else {
                year = year + 1;
                console.log('EnrollmentEndDate is in Fiscal year : ' + year);
                var reimbursementSubmissionCutoffDt = new Date(year, 10, 15);
              }
              console.log("ReimbursementPage- cutoffDt: " + reimbursementSubmissionCutoffDt );
             // console.log("Formatted cutoffDt: " + this.dateUtility.convertDateFromServer(reimbursementSubmissionCutoffDt) );
            
              let currentDt = new Date();
              //let currentDt = new Date(2024, 10, 18);
              console.log("Current Date: " + currentDt);
              //console.log("Current Date: " + this.dateUtility.convertDateFromServer(currentDt));

              if(currentDt > reimbursementSubmissionCutoffDt) {
                this.disableAddNew = true;
              } else {
                this.disableAddNew = false;
              }
              console.log("disableAddNew : " + this.disableAddNew );
              
  
            }
          } 

        },
        response => {
          this.notificationService.error('Enrollment', this.userActionNotificationsMap.ERROR);
        },
        () => {
          
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/reimbursements-summary/reimbursements-summary.component.ts